import { APP_NAME } from "@/utils/enum";

export interface MenuItem {
  id: number;
  title: string;
  class_name?: string;
  link: string;
  has_dropdown: boolean;
  openNewTab?: boolean;
  sub_menus?: {
    link: string;
    title: string;
    external?: boolean;
    section?: boolean;
    has_dropdown?: boolean;
    nested_sub_menus?: {
      link: string;
      title: string;
      external?: boolean;
      section?: boolean;
      redirect?: boolean;
    }[];
  }[];
  menu_column?: {
    id: number;
    mega_title: string;
    mega_menus: {
      link: string;
      title: string;
    }[];
  }[];
  external?: boolean;
}

const VibgyorVivaMenuData: MenuItem[] = [
  {
    id: 1,
    has_dropdown: false,
    title: "Home",
    link: "/",
  },
  {
    id: 3,
    has_dropdown: false,
    title: "Events",
    class_name: "mega-dropdown-sm",
    link: "/events",
  },
  {
    id: 5,
    has_dropdown: false,
    title: "Schedule",
    link: "/schedule",
  },
  {
    id: 6,
    has_dropdown: false,
    title: "LeaderBoard",
    link: "/leaderboard",
  },
  {
    id: 7,
    has_dropdown: true,
    title: "Media",
    link: "/media",
    sub_menus: [
      {
        link: "/photos",
        title: "Photo Gallery",
      },
      {
        link: "/videos",
        title: "Video Gallery",
      },
    ],
  },
  {
    id: 2,
    has_dropdown: false,
    title: "About Us",
    link: "/about-us",
  },
  // {   // added in profile icon
  //   id: 4,
  //   has_dropdown: false,
  //   title: "My Events",
  //   link: "/orderhistory",
  // },
  {
    id: 8,
    has_dropdown: false,
    title: "Contact Us",
    link: "/contact-us",
  },
  {
    id: 9,
    has_dropdown: false,
    title: " Live",
    link: "/live",
  },
];

const SummerCampMenuData: MenuItem[] = [
  {
    id: 1,
    has_dropdown: false,
    title: "Home",
    link: "/",
  },
  {
    id: 2,
    has_dropdown: true,
    title: "Camps",
    link: "/camps",
    sub_menus: [
      {
        title: "Camp Activities",
        link: "/summer-camp",
      },
      // {
      //   title: "Sports Camp",
      //   link: "/events",
      // },
    ],
  },
  {
    id: 3,
    has_dropdown: false,
    title: "VC3",
    class_name: "mega-dropdown-sm",
    link: "/vc3",
  },
  {
    id: 4,
    has_dropdown: false,
    title: "VSPA",
    class_name: "mega-dropdown-sm",
    link: "/psa",
  },
  {
    id: 5,
    has_dropdown: false,
    title: "Global Immersion",
    class_name: "mega-dropdown-sm",
    link: "/tgip",
  },
  {
    id: 6,
    has_dropdown: false,
    title: "VAFP",
    class_name: "mega-dropdown-sm",
    link: "/vafp",
  },
  // {
  //   id: 7,
  //   has_dropdown: false,
  //   title: "V-EMBARK",
  //   class_name: "mega-dropdown-sm",
  //   link: "/v-embark",
  // },
  {
    id: 8,
    has_dropdown: false,
    title: "Tours",
    class_name: "mega-dropdown-sm",
    link: "/tours",
  },
  {
    id: 9,
    has_dropdown: false,
    title: "External Exams",
    class_name: "mega-dropdown-sm",
    link: "/e-examination",
  },
  {
    id: 9,
    has_dropdown: false,
    title: "Concert Costume",
    class_name: "mega-dropdown-sm",
    link: "/viva-concert-kit",
  },
  // {
  //   id: 7,
  //   has_dropdown: false,
  //   title: "My Activity",
  //   link: "/orderhistory",
  // },
  // {
  //   id: 6,
  //   has_dropdown: true,
  //   title: "Media",
  //   link: "/media",
  //   sub_menus: [
  //     {
  //       link: "/photos",
  //       title: "Photo Gallery",
  //     },
  //     {
  //       link: "/videos",
  //       title: "Video Gallery",
  //     },
  //   ],
  // },
];
const SummerCampPrivateMenuData: MenuItem[] = [
  {
    id: 2,
    has_dropdown: false,
    title: "Tours",
    link: "/tours",
  },
  {
    id: 1,
    has_dropdown: false,
    title: "Summer Camp",
    link: "/summer-camp",
    // sub_menus: [
    //   {
    //     title: "Camp Activities",
    //     link: "/summer-camp",
    //   },
    //   {
    //     title: "Summer Events",
    //     link: "/events",
    //   },
    // ],
  },
];
export const MenuItems: { [key: string]: MenuItem[] } = {
  [APP_NAME.VIBGYOR_VIVA]: VibgyorVivaMenuData,
  [APP_NAME.VIBGYOR_ONE]: SummerCampMenuData,
  [APP_NAME.SUMMER_CAMP_PRIVATE]: SummerCampPrivateMenuData,
};
